import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { getContractListingType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getContractListing = (payload: getContractListingType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getContractListing`,
        payload
      );
      dispatch({
        type: action_types.GET_CONTRACTS_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_CONTRACTS_LISTING,
        data: { loading: false, payload: [], count: 0 },
      });
    }
  };
};

export const removeContractListData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_CONTRACTS_LISTING,
      data: { payload: [], loading: true },
    });
  };
};

export const getContractById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getContractById/${id}`);
      dispatch({
        type: action_types.GET_CONTRACTS_DETAIL,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_CONTRACTS_DETAIL,
        data: { loading: false },
      });
    }
  };
};

export const removeContractDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_CONTRACTS_DETAIL,
      data: { payload: {}, loading: true },
    });
  };
};

export const getChangeOrderDocumentData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(
        `${baseURL}getChangeOrderDocumentData/${id}`
      );
      dispatch({
        type: action_types.GET_CHANGE_ORDER_DOCUMENT,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_CHANGE_ORDER_DOCUMENT,
        data: { loading: false, payload: {} },
      });
    }
  };
};

export const getContractDetailById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getContractDetailById/${id}`);
      dispatch({
        type: action_types.GET_CONTRACT_DETAIL_BY_ID,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_CONTRACT_DETAIL_BY_ID,
        data: { loading: false, payload: {} },
      });
    }
  };
};
